export const githubMarketplace = 'https://github.com/apps/stackshare-enterprise';
